import PortalPage from "@/components/PortalPage";

export default function OrganizationPortal() {
  return (
    <PortalPage
      portal="ORGANIZATION"
      title="Run your whole factory on one platform."
      tagline="From kiln to customer — manufacturing, inventory, sales, finance, and CRM in a single workspace. Configured per role, governed by audit."
      gradient="from-emerald-700 via-emerald-900 to-black"
      heroBg="🏭"
      accentColor="from-emerald-400 to-teal-400"
      benefits={[
        { title: "Manufacturing-first", body: "Built around kilns, batches, QC and yield — not generic ERP fields." },
        { title: "Multi-plant ready", body: "Switch warehouses, plants and brands from one Org Admin console." },
        { title: "Audit & compliance", body: "Every approval, edit and login is logged, exportable and tamper-evident." },
        { title: "Role-precise", body: "23 built-in org roles — each with its own data view, permissions and KPIs." },
        { title: "Marketplace-connected", body: "Push catalog to vendor portal + dealer storefront with one toggle." },
        { title: "API-first", body: "REST + webhooks — Tally, SAP, Zoho and 100+ integrations are plug-in." },
      ]}
      features={[
        "Production planning, kiln batches, QC sign-off",
        "Multi-location inventory with bin-level tracking",
        "GRN → Pick → Pack → Dispatch with barcode",
        "Sales orders, CRM, lead tracking, visit scheduling",
        "Dealer & distributor onboarding from same console",
        "Multi-tier approval workflows (configurable per amount)",
        "Stripe + Razorpay + custom payment gateways",
        "GST-ready invoicing, e-way bills, e-invoice",
        "Dedicated mobile apps for sales executives",
        "Branded buyer portal under your domain",
        "SLA-backed support (Enterprise: 1h response)",
      ]}
      faqs={[
        { q: "Can I migrate from Tally / SAP?", a: "Yes — we provide guided migration with import templates and a CSM-led cutover for Enterprise plans." },
        { q: "How are roles billed?", a: "Each role above the plan default costs a small per-user/mo fee. The subscription builder shows the price live." },
        { q: "Is data isolated between tenants?", a: "Yes — strict tenant_id filtering at the DB layer. Super Admin can impersonate for support with full audit." },
        { q: "Do you offer on-premise deployment?", a: "Enterprise customers can opt for VPC-isolated or on-prem deployment. Contact sales." },
        { q: "What's the trial period?", a: "Basic: 14 days. Premium: 21 days. Enterprise: 30 days. No credit card needed to start." },
      ]}
    />
  );
}
